module.exports = __webpack_public_path__ + "static/media/report-empty.61d2f8fd.svg";